import "./Client.scss";

const ClientCasinoResults = () => {
  return (
    <div className="w777-page">
      <h2 className="w777-page-title">Casino Results</h2>

      <div className="w777-search-row">
        <input type="search" placeholder="Search" readOnly />
        <span className="w777-search-ico" aria-hidden="true">
          ⌕
        </span>
      </div>

      <div className="w777-data-table-wrap">
        <table className="w777-data-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Game</th>
              <th>Round</th>
              <th>Result</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={4} className="w777-empty-cell">
                no records found
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientCasinoResults;
